import React from 'react';
import ENUMS from '../../enums/index';
import MenuCategoryDetails from './modals/menuCategoryDetails';
import DeleteMenuCategory from './modals/deleteMenuCategory';
import { connect } from 'react-redux';
import * as menuCategoriesActions from '../../redux/menuCategories/actions';
import Spin from '../../components/loading';
import EditMenuCategories from './modals/insertNewMenuCategory';
import ShowForPermission from '../../components/ShowForPermission';

class MenuCategoriesTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuCategoryOpen: false,
      selectedTitle: '',
      selectedMenuCategoryId: null,
      editMenuCategoriesOpen: false,
      deleteMenuCategoryOpen: false,
      isActive: false
    };
  }

  closeMenuCategoryModal = () => {
    this.props
      .fetchAllMenuCategories(`pageNumber=${this.props.pageNumber}&pageSize=${this.props.pageSize}`)
      .then(() => {
        this.setState(() => ({
          menuCategoryOpen: false
        }));
      });
  };
  closeDeleteMenuCategoryOpen = () => {
    this.props
      .fetchAllMenuCategories(`pageNumber=${this.props.pageNumber}&pageSize=${this.props.pageSize}`)
      .then(() => {
        this.setState(() => ({
          deleteMenuCategoryOpen: false
        }));
      });
  };

  displayMenuCategoryModal = id => {
    this.setState({ menuCategoryOpen: true });
  };

  displayDeleteMenuCategoryOpen = id => {
    let { menuCategoriesList = [] } = this.props;
    let selectedMenuCategoryId = menuCategoriesList.filter(menuCategory => menuCategory.id == id)[0].id;
    let selectedTitle = menuCategoriesList.filter(menuCategory => menuCategory.id == id)[0].title;
    this.setState({ deleteMenuCategoryOpen: true, selectedMenuCategoryId, selectedTitle });
  };

  changeMenuCategoryActivity = (id, isActive) => {
    this.props.changeMenuCategoryActivity(id, !isActive).then(() => {
      this.props.fetchAllMenuCategories(
        `pageNumber=${this.props.pageNumber}&pageSize=${this.props.pageSize}`
      );
    });
  };

  closeEditMenuCategoriesModal = () => {
    this.props
      .fetchAllMenuCategories(`pageNumber=${this.props.pageNumber}&pageSize=${this.props.pageSize}`)
      .then(() => {
        this.setState(() => ({
          editMenuCategoriesOpen: false
        }));
      });
  };

  displayEditMenuCategoriesModal = id => {
    let { menuCategoriesList = [] } = this.props;
    let selectedMenuCategoryId = menuCategoriesList.filter(menuCategory => menuCategory.id == id)[0].id;
    this.setState({ editMenuCategoriesOpen: true, selectedMenuCategoryId });
  };

  render() {
    let {
      menuCategoriesList = [],
      pageNumber,
      pageSize,
      loading,
      error,
      message,
      faield,
      statusLoading,
      statusMessage,
      statusFailed,
      statusError
    } = this.props;
    return (
      <>
        <Spin spinning={loading || statusLoading}>
          <table className="table table-hover table-light table-striped">
            <thead>
              <tr>
                <th className="text-center">{locales('tables.row')}</th>
                <th className="text-center ">{locales('tables.title')}</th>
                <th className="text-center">{locales('tables.activated')}</th>
                <th className="text-center">{locales('tables.displayOrder')}</th>
                <th className="text-center">{locales('tables.registrar')}</th>
                <th className="text-center">{locales('tables.creationDate')}</th>
                <th className="text-center"></th>
                <th className="text-center"></th>
                <th className="text-center"></th>
              </tr>
            </thead>
            <tbody>
              {menuCategoriesList.length ? (
                menuCategoriesList.map((menuCategory, index) => (
                  <tr key={menuCategory.id}>
                    <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td className="text-center">{menuCategory.title}</td>
                    <td className="text-center">
                      <i
                        className={`${
                          menuCategory.isActive
                            ? 'fal fa-check-square text-success'
                            : 'fal fa-times-square text-danger'
                        }`}
                      />
                    </td>
                    <td className="text-center">{menuCategory.displayOrder || '---'}</td>
                    <td className="text-center">{menuCategory.createdFullName}</td>
                    <td className="text-center">{menuCategory.createdAt}</td>
                    <ShowForPermission permission={ENUMS.PERMISSIONS.values.ACTIVE_INACTIVE_MENU_CATEGORY}>
                      <td>
                        <button
                          className={`${menuCategory.isActive ? 'btn-danger' : 'btn-success'} btn btn-sm`}
                          onClick={() =>
                            this.changeMenuCategoryActivity(menuCategory.id, menuCategory.isActive)
                          }
                        >
                          {locales(menuCategory.isActive ? 'tables.deactivate' : 'tables.activate')}
                        </button>
                      </td>
                    </ShowForPermission>
                    <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_MENU_CATEGORY}>
                      <td title={locales('titles.editCategory')}>
                        <i
                          onClick={() => this.displayEditMenuCategoriesModal(menuCategory.id)}
                          className="text-center fa fa-pencil text-secondary pointer"
                        />
                      </td>
                    </ShowForPermission>
                    <ShowForPermission permission={ENUMS.PERMISSIONS.values.DELETE_MENU_CATEGORY}>
                      <td title={locales('titles.deleteCategory')}>
                        <i
                          onClick={() => this.displayDeleteMenuCategoryOpen(menuCategory.id)}
                          className="text-center fal fa-trash text-danger pointer"
                        />
                      </td>
                    </ShowForPermission>
                  </tr>
                ))
              ) : (
                <tr className="col-12 text-center">
                  <td className="alert alert-info" colSpan={12}>
                    {locales('alerts.noRecord')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {this.state.editMenuCategoriesOpen && (
            <EditMenuCategories
              isOpen={this.state.editMenuCategoriesOpen}
              closeModal={this.closeEditMenuCategoriesModal}
              menuCategoryId={this.state.selectedMenuCategoryId}
            />
          )}
          {this.state.menuCategoryOpen && (
            <MenuCategoryDetails
              isOpen={this.state.menuCategoryOpen}
              closeModal={this.closeMenuCategoryModal}
            />
          )}
          {this.state.deleteMenuCategoryOpen && (
            <DeleteMenuCategory
              title={this.state.selectedTitle}
              isOpen={this.state.deleteMenuCategoryOpen}
              menuCategoryId={this.state.selectedMenuCategoryId}
              closeModal={this.closeDeleteMenuCategoryOpen}
            />
          )}
        </Spin>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    menuCategoriesList: state.menuCategoriesReducer.menuCategoriesList,
    loading: state.menuCategoriesReducer.menuCategoriesLoading,
    message: state.menuCategoriesReducer.menuCategoriesMessage,
    failed: state.menuCategoriesReducer.menuCategoriesFailed,
    error: state.menuCategoriesReducer.menuCategoriesError,

    statusLoading: state.menuCategoriesReducer.changeMenuCategorieStatusLoading,
    statusMessage: state.menuCategoriesReducer.changeMenuCategorieStatusMessage,
    statusFailed: state.menuCategoriesReducer.changeMenuCategorieStatusFailed,
    statusError: state.menuCategoriesReducer.changeMenuCategorieStatusError
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllMenuCategories: query => dispatch(menuCategoriesActions.fetchAllMenuCategories(query)),
    changeMenuCategoryActivity: (id, isActive) =>
      dispatch(menuCategoriesActions.changeMenuCategoryActivity(id, isActive))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuCategoriesTable);
